export default __webpack_public_path__ + "static/for-cros-6e01fc9dfa61b47ab02dbea454194df3.png";